import _ from 'lodash';
import { Component, Vue, Provide } from 'vue-property-decorator';
import { Bot } from '@/dtos/bot';
import { runInterval } from '@/services/VueTimmer';
import { getServerTimestamp } from '@/apis/authorize.api';
import { Getter } from 'vuex-class';
import { BotInstance } from '@/dtos/Instance';
import { removeBot } from '@/apis/bot.api';

@Component
export default class BotUtilMixins extends Vue{
  @Provide()
  time = Date.now();
  
  @Provide()
  deltaTime = 0;

  get actualServerTime() {
    return this.time + this.deltaTime;
  }

  @runInterval(1000)
  updateTime(){
    this.time = Date.now()
  }

  mounted() {
    getServerTimestamp().then(e => {
      this.deltaTime = e.timestamp - Date.now();
    });
  }

  @Getter('project/instances')
  instances!: { [k: string]: BotInstance };

  getBotStatus(bot: Bot) {
    if (bot.botStat && bot.botStat.instance) {
      if (bot.status) {
        if (this.actualServerTime - bot.status.last_ping <= 12000)
          return 'RUNNING';
        if (bot.status.msg == 'SUCCESS') return 'WAIT-SIGNAL';
        if (bot.status.msg) return bot.status.msg;
        if (!bot.enable) return 'STOPPED';
      }
      let instance = this.instances[bot.botStat.instance];
      let instanceStatus = _.get(instance,"status.status")
      if(['CREATING','LOADING'].includes(instanceStatus))
        return 'LOADING-INSTANCE';
      if (instanceStatus == 'FAILED')
        return 'ALLOCATE-FAILED';
    }
    return bot.enable ? 'ALLOCATING' : 'STOPPED';
  }


  removeBot(id) {
    this.$swal({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
    }).then(result => {
      if (result.value) {
        removeBot(id)
          .then(() => {
            this.$swal('Deleted!', 'Bot has been deleted.', 'success').then(
              () => {
                // location.reload();
              },
            );
          })
          .catch((error) => {
            this.$popupError(error);
          });
      }
    });
  }

}